import axios from "axios";

export const saveNamedTicket = async ({ getters, commit }, tickets) => {
  let payload = tickets
    .filter((t) => t.dados_extras)
    .map(async (t) => {
      let pm = new Promise((resolve) => {
        Promise.all(
          t.dados_extras.map(async (de) => {
            if (de.tipo === "secao") de.valor = de.titulo;
            if (de.tipo === "upload_arquivo" || de.tipo === "upload_imagem") {
              if (de.tipo === "upload_arquivo") {
                let params = new FormData();
                params.append("image", de.file);
                params.append("event_id", tickets[0].codigo_evento);
                params.append("ticket_id", tickets.ticket);

                return axios({
                  method: "post",
                  url: "/v2/tickets/assign/upload",
                  data: params,
                  headers: { "Content-Type": "multipart/form-data" },
                }).then(function (response) {
                  de.valor = response.data.url;
                  return {
                    codigo: de.codigo,
                    valor: de.valor,
                  };
                });
              }
              if (de.tipo === "upload_imagem") {
                let params = new FormData();
                params.append("image", de.image);
                params.append("event_id", tickets[0].codigo_evento);
                params.append("ticket_id", tickets.ticket);

                return axios({
                  method: "post",
                  url: "/v2/tickets/assign/upload",
                  data: params,
                  headers: { "Content-Type": "multipart/form-data" },
                }).then(function (response) {
                  de.valor = response.data.url;
                  return {
                    codigo: de.codigo,
                    valor: de.valor,
                  };
                });
              }
            } else {
              return {
                codigo: de.codigo,
                valor: de.valor,
              };
            }
          })
        ).then((resp) => {
          resolve(resp);
        });
      });
      return pm.then(function (e) {
        return {
          ticket_id: t.codigo || t.codigo_barras,
          extradata: e,
        };
      });
    });

  return Promise.all(payload).then(async (values) => {
    let result = {
      tickets: JSON.parse(JSON.stringify(values)),
      order_hash: getters.orderDetails.hash_pedido,
    };
    return await axios
      .post(
        `orders/tickets/assign/${
          tickets[0].codigo_evento
            ? tickets[0].codigo_evento
            : getters.orderDetails.codigo_evento
        }`,
        result
      )
      .then((resp) => {
        commit("SET_LAST_ORDER_AND_CART", {
          ...getters.lastOrderAndCart,
          route: "Payment",
        });
        return resp;
      });
  });
};

export const getGlobalPlaces = async ({ commit }, query) => {
  commit("SET_ALL_EVENT_PLACES", null);
  try {
    const response = await axios.get(`v2/city/search?query=${query}`);
    let results = [];

    if (response && response.data) {
      response.data.forEach((l) => {
        let result = {
          description: `${l.name}, ${l.state} - Brasil`,
        };
        results.push(result);
      });
      commit("SET_ALL_EVENT_PLACES", results);
    }
  } catch (error) {
    console.error("Failed retrieving event data", error);
    throw error;
  }
};
